"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const warning_message_1 = __importDefault(require("components/common/warning-message"));
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const utils_1 = require("core/utils");
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class HouseholdMemberFields extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errorDismissed: false };
        this.dismissAgeMessage = this.dismissAgeMessage.bind(this);
        this.resetAgeMessage = this.resetAgeMessage.bind(this);
    }
    getGenderOptions() {
        return [
            { text: 'No Selection', value: '' },
            { text: 'Male', value: 'male' },
            { text: 'Female', value: 'female' },
        ];
    }
    resetAgeMessage() {
        this.setState({ errorDismissed: false });
    }
    dismissAgeMessage() {
        this.setState({ errorDismissed: true });
    }
    render() {
        const { isChild, birthdayChanged, selectedMemberType, change } = this.props;
        const { errorDismissed } = this.state;
        const birthdatePickerProps = {
            showMonthDropdown: true,
            showYearDropdown: true,
            maxDate: (0, utils_1.todayMoment)(),
            popperPlacement: 'top-start',
        };
        return (React.createElement("div", null,
            birthdayChanged && isChild && !errorDismissed && (React.createElement(warning_message_1.default, { message: "Members under 13 will be added as children.", onDismiss: this.dismissAgeMessage })),
            React.createElement("div", { className: "Form-section" },
                React.createElement("div", { className: "section-title" }, "Member Type"),
                React.createElement(redux_form_1.Field, { id: "memberType", name: "memberType", type: "radio", value: selectedMemberType, component: form_field_element_1.default, isInline: true, options: [
                        { text: 'Adult', value: 'Adult' },
                        { text: 'Teen', value: 'Teen' },
                        { text: 'Child', value: 'Child' },
                    ] })),
            React.createElement("div", { className: "Form-section" },
                React.createElement("div", { className: "section-title" }, "Member Info"),
                React.createElement("div", { className: "Grid Grid--withGutter" },
                    React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-size1of2" },
                        React.createElement(redux_form_1.Field, { id: "firstName", name: "firstName", component: form_field_element_1.default, type: "text", label: "First Name", fieldGroupClass: "autoFocus", maxLength: 40 })),
                    React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-size1of2" },
                        React.createElement(redux_form_1.Field, { id: "lastName", name: "lastName", component: form_field_element_1.default, type: "text", label: "Last Name", maxLength: 40 }))),
                React.createElement("div", { className: "Grid Grid--withGutter" },
                    React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-size1of2" },
                        React.createElement(redux_form_1.Field, { id: "birthdate", name: "birthdate", component: form_field_element_1.default, type: "date", label: "Birthday", resetAgeMessage: this.resetAgeMessage, dateProps: birthdatePickerProps, change: change })),
                    React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-size1of2" },
                        React.createElement(redux_form_1.Field, { id: "gender", component: form_field_element_1.default, type: "select", name: "gender", label: "Gender", className: "gender", options: this.getGenderOptions() }))),
                !isChild && (React.createElement(redux_form_1.Field, { id: "emailAddress", name: "emailAddress", component: form_field_element_1.default, type: "email", placeholder: "Household invite will be sent to this email", label: React.createElement("span", null,
                        "Member Email ",
                        React.createElement("span", { className: "optional" }, "(optional)")), maxLength: 150 })))));
    }
}
exports.default = HouseholdMemberFields;
